import ListProcesses from "@/views/agro_exporter/reporting/process/ListProcesses.vue";
import ListReports from "@/views/agro_exporter/reporting/process/ListReports.vue";

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "ae",
  role: "reporting",
  permission: "process",
});

export default [
  {
    path: "/ae/:agro_exporter_id/reporting/process/list_processes",
    name: routeName(""),
    redirect: { name: routeName("list_processes") }
  },
  {
    path: "/ae/:agro_exporter_id/reporting/process/list_processes",
    name: routeName("list_processes"),
    component: ListProcesses,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/reporting/process/:agro_exporter_process_id/reports",
    name: routeName("reports"),
    component: ListReports,
    props: true,
    meta: META
  }
];
